<template>
  <!-- password change screen, email sent to the user to proceed with the change. Link located on the login screen -->
  <div class="container-fluid py-5">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-4 mx-auto">
        <div class="card card-signin my-4 card-opacity">
          <div class="card-body">
            <button
              @click="backLogin"
              id="backRecoveryEmail"
              style="cursor: pointer; background-color: transparent"
              class="btn accordion-toggle"
            >
              <em class="fa fa-chevron-left icon-chevron"></em>
            </button>
            <img
              class="mx-auto rounded mx-auto d-block logo-image"
              alt="logoImage"
              :src="logoImage"
            />
            <h5 class="card-title text-center text-join">Recuperar senha</h5>
            <div style="display: flex; justify-content: center">
              <p class="text-align-center">
                Encaminharemos um e-mail para que possa redefinir sua senha.
              </p>
            </div>
            <form
              @submit.prevent="requestResetPassword"
              class="form-signin"
              autocomplete="off"
              style="margin-bottom: -65px"
            >
              <div class="form-label-group">
                <label for="userRecoveryEmail label-config">Usuário</label>

                <input
                  type="text"
                  id="userRecoveryEmail"
                  class="form-control input-length"
                  placeholder="Digite seu usuário"
                  v-model="login"
                  required
                  autofocus
                />
                <span v-if="errors.login" class="error">
                  <ul>
                    <li v-for="msg in errors.login">{{ msg }}</li>
                  </ul>
                </span>
              </div>

              <div class="access-center">
                <button class="btn btn-lg access-recovery" id="sendRecoveryEmail" type="submit">
                  Enviar e-mail
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "RecoveryEmail",
  data() {
    return {
      logoImage: "",
      login: "",
      email: "",
      group: "",
      errors: [],
    };
  },

  mounted() {
    let group = localStorage.group;
    this.token = this.$route.query.token;
    this.key = this.$route.query.key;

    if (group) {
      axios.get(process.env.API_PBM + "/group/" + group).then((response) => {
        let background = response.data.data.background;
        let logo = response.data.data.logo;
        this.group = response.data.data.id;
        if (background != null) {
          document.body.className = "background-login";
          document.body.style.backgroundImage = `url("${background}")`;
        }
        this.logoImage = logo != null ? logo : "";
      });
    }
  },
  methods: {
    requestResetPassword() {
      this.errors = [];
      axios
        .post(`${process.env.API_PBM}/user/password/reset`, {
          login: this.login,
          email: this.email,
          grp_id: this.group,
        })
        .then((result) => {
          this.response = result.data;
          if (this.response.status === "success") {
            this.$router.push(
                {
                  name: "NewPasswordConfirmation",
                  query: {
                    maskedEmail: this.response.data.email
                  }
                }
            );
          }
        })

        .catch((error) => {
          Vue.$toast.error("Ops! Usuário não encontrado.", {
            position: "top-right",
            duration: 5000,
          });
        });
    },
    backLogin: function () {
      this.$router.push({ path: localStorage.getItem("group") }).catch(() => {});
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-top: 50px;
}
.error {
  font-size: 13px;
  color: #b0191a;
  margin-left: 10px !important;
  width: 87%;
  margin-top: -18px;
}

.input-length {
  margin: 0 auto;
}
.card-opacity {
  background: rgba(255, 255, 255, 0.9);
  border: none;
}

label {
  display: inline-block;
  font-size: 17px;
  margin-top: 10px;
  color: rgb(100, 95, 95);
}

.text-align-center {
  margin-top: 5px;
  margin-left: 42px;
  color: rgb(100, 95, 95);
  font-size: 14px;
  text-align: left;
}
.access-recovery {
  background-color: var(--colorDefault);
  color: #fff;
  width: 40%;
  margin-top: 20px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  margin-bottom: 70px;
  text-decoration: none !important;
}
.access-recovery:hover{
  background-color: var(--colorDefaultActiveHover);
}
.access-center {
  text-align: center;
}

@media only screen and (max-width: 900px) {
  .access-recovery {
    color: #fff;
    width: 40%;
    margin-top: 20px;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 17px;
    margin-bottom: 70px;
    text-decoration: none !important;
  }
}

@media only screen and (min-width: 1340px) {
  /* styles for browsers larger than 1440px; */
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
}

@media only screen and (max-width: 1940px) {
}

@media only screen and (min-width: 2000px) {
  /* for sumo sized (mac) screens */
}
</style>



// WEBPACK FOOTER //
// src/views/components/forgotPassword/RecoveryEmail.vue